import { GetNavigator } from "./GetNavigator"

/** `navigator.storage.getDirectory`, bound to the storage manager, or
 * `undefined` where the environment has no origin private file system (node,
 * and browsers older than the API).
 *
 * Bound rather than plucked: it is a method, and one called loose throws. */
export const GetStorageDirectory = (): (() => Promise<FileSystemDirectoryHandle>) | undefined => {
  const storage = GetNavigator()?.storage
  return storage?.getDirectory?.bind(storage)
}
